enum TextType {
  Plain = 'text_plain',
  Html = 'text_html',
}

export { TextType };
